<template>
  <div>
    <task-detail @onSave="taskSaved()" @onDelete="paginate()" />
    <!-- <policy-detail @onSave="paginate" :product="product" /> -->

    <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center" style="gap: 2.34rem;">
        <div>
          <h1 class="title">{{ $t("policy.organization") }}</h1>
        </div>
        <div class="search2">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input v-model="nameFilter" class="search2--input" type="text" :placeholder="$t('common.search')" />
        </div>
        <div class="" style="min-width:300px;">
          <filter-select
            key="policyGroupFilter"
            id="policyGroupFilter"
            ref="policyGroupFilter"
            :placeholder="$t('policy-group.text')"
            :selected="policyGroupFilter"
            @filter="onPolicyGroupSearch"
            @changed="onPolicyGroupSelect"
          />
        </div>

        <div class="d-flex" style="min-width:300px;">
          <label class="text-muted">{{ $t("policy-category.text") }}</label>
          <select class="form-control " v-model="selectedCategoryFilter">
            <option :value="null">{{ $t("common.all") }}</option>
            <option value="ADMINISTRATIVE">{{ $t("policy-category.administrative") }}</option>
            <option value="TECHNICAL">{{ $t("policy-category.technical") }}</option>
            <option value="LEGAL">{{ $t("policy-category.legal") }}</option>
          </select>
        </div>
      </div>
      <!-- <div v-if="hasUnworkedPermission" class="d-flex align-items-center" @click="create">
        <div class="new-task-text">{{ $t("policy.new") }}</div>
        <div class="plus-button" style="margin-right: 1.56rem;"></div>
      </div> -->
    </div>
    <div class="d-flex align-items-center float-right ml-4" @click="toggleRightPanel">
      <div class="new-task-text">{{ $t("policy.new") }}</div>
      <div class="plus-button" style="margin-right: 1.56rem;"></div>
    </div>

    <b-dropdown split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="mb-4 mr-4 mt-1 float-right">
      <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
    </b-dropdown>
    <div>
      <right-panel id="sidebar-new-policy" width="1050px" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <OrganizationPolicyForm :hide-library="true" :closeOnSave="false" ref="OrganizationPolicyForm" />
        </div>
      </right-panel>
    </div>
    <nav class="tab-menu w-100 text-center">
      <div v-if="hasUnworkedPermission" :class="{ active: workedFilter === 'WAITING_FOR_ASSESSMENT' }" @click="setWorkedFilter('WAITING_FOR_ASSESSMENT')">
        {{ $t("policy.waiting-for-assignment-items") }}
      </div>
      <div :class="{ active: workedFilter === 'IN_PROGRESS' }" @click="setWorkedFilter('IN_PROGRESS')">{{ $t("policy.in-progress-items") }}</div>
      <div :class="{ active: workedFilter === 'WAITING_FOR_PERIOD' }" @click="setWorkedFilter('WAITING_FOR_PERIOD')">{{ $t("policy.periodic-items") }}</div>
      <div :class="{ active: workedFilter === 'COMPLETED' }" @click="setWorkedFilter('COMPLETED')">{{ $t("policy.completed") }}</div>
      <div :class="{ active: workedFilter === 'NOT_APPLICABLE' }" @click="setWorkedFilter('NOT_APPLICABLE')">{{ $t("policy.out-of-scope") }}</div>
    </nav>

    <div class="pt-4 ">
      <content-loading v-if="isLoading" />
      <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="200px" />

      <div v-if="pagination && pagination.docs.length > 0" class="d-flex flex-wrap justify-content-start">
        <div v-for="policy in pagination.docs" :key="policy._id" class="pcard d-flex flex-column mr-4 w-45 ">
          <PolicyDeleteModal @hidden="deleteModalHidden" :policy="policy" :id="'policy-delete-modal' + policy._id" />

          <div class="d-flex flex-row justify-content-end">
            <div class="ml-4 mr-4" v-if="'NOT_APPLICABLE' != policy.status">
              <policy-periodical-select @onSave="periodEdited($event, policy)" @onStatusChanged="statusChanged($event, policy)" :policy="policy"></policy-periodical-select>
            </div>
            <div class="action font-size-24 ml-1 mr-1" @click="redirectToRelatedFiles(policy)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page hand"></i>
            </div>
            <div>
              <div class="text-right">
                <i
                  v-if="'NOT_APPLICABLE' != policy.status && 'WAITING_FOR_PERIOD' != policy.status"
                  class="bx bx-edit text-primary hand font-size-24 mr-2"
                  v-b-tooltip.hover
                  :title="$t('common.edit')"
                  @click="edit(policy._id)"
                ></i>
                <i
                  v-if="!['COMPLETED', 'NOT_APPLICABLE'].includes(policy.status)"
                  class="iconoir-prohibition text-danger hand font-size-24"
                  v-b-tooltip.hover
                  :title="$t('policy.out-of-scope')"
                  @click="deletePolicy(policy)"
                ></i>
              </div>
              <div class="text-right">
                <i
                  v-if="'NOT_APPLICABLE' == policy.status"
                  class="iconoir-prohibition text-success hand h3"
                  v-b-tooltip.hover
                  :title="$t('policy.within-scope')"
                  @click="revertDeleted(policy)"
                ></i>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- <policy-status-select :policy="policy" @onSelect="paginate" /> -->
            <div class="col-md-12">
              <div class="pcard--title text-break">
                <div>
                  <span class="hand" @click="edit(policy._id)">
                    <h4>{{ $t("policy.name") }}</h4>
                    {{ policy.name | translate }} </span
                  ><br />
                </div>
                <h4 class="mt-3">{{ $t("policy-category.text") }}</h4>
                <small><policy-category-badge :policy="policy"/></small>
              </div>
              <div>
                <div class="" style="gap: 1rem;">
                  <div v-if="policy.description" class="pcard--description">
                    <div class="pcard--title">{{ $t("common.description") }}</div>
                    <div class="pcard--description--text">
                      {{ policy.description | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!------<pre>{{ policy }}</pre>------>

          <h4>{{ $t("policy.related-compliances") }}</h4>
          <table class="table table-bordered table-striped bg-white">
            <thead class="bg-secondary text-white">
              <tr>
                <td class="w-10">{{ $t("policy.compliance") }}</td>
                <td class="w-10">{{ $t("policy-group.text") }}</td>
                <td class="w-10">{{ $t("policy.no") }}</td>
                <td class="w-10">{{ $t("policy.level") }}</td>
                <td class="w-60">{{ $t("policy.definition") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="compliance in policy.compliances" :key="compliance._id">
                <td>{{ compliance.product }}</td>
                <td>{{ compliance.policyGroup.name | translate }}</td>
                <td>{{ compliance.policyNo }}</td>
                <td>{{ compliance.policyLevel }}</td>
                <td>{{ compliance.policyDefinition | translate }}</td>
              </tr>
            </tbody>
          </table>

          <h4>{{ $t("policy.related-risks") }}</h4>
          <div>
            <div class="pcard--title" style="margin-bottom: 0.8rem;">
              <span
                v-if="policy.showRiskLinkPanel"
                class="add-button hand"
                @click="
                  policy.showRiskLinkPanel = true;
                  $forceUpdate();
                "
              >
                {{ $t("common.link-with") }}
                <i class="iconoir-plus font-size-24"></i>
              </span>
            </div>

            <b-row v-if="policy.showRiskLinkPanel" class="mb-3">
              <b-col>
                <filter-select :id="'riskFilter'" :ref="'riskFilter'" :placeholder="$t('risk.text')" @filter="onRiskSearch" @changed="onRiskSelect($event)" />
              </b-col>
              <b-col md="3">
                <b-button @click="linkWithRisk(policy)" :disabled="!selectedRisk" class="btn-block btn-success">{{ $t("common.link-with") }}</b-button>
              </b-col>
            </b-row>
          </div>
          <table class="table table-bordered table-striped bg-white">
            <thead class="bg-secondary text-white">
              <tr>
                <td class="w-10">{{ $t("risk.name") }}</td>
                <td class="w-10">{{ $t("risk.threat-definition.text") }}</td>
                <td class="w-10">{{ $t("risk.weakness-definition.text") }}</td>
                <td class="w-5"></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="risk in policy.risks" :key="risk._id">
                <td>{{ risk.name | translate }}</td>
                <td>{{ displayDefinitions(risk.threats) }}</td>
                <td>{{ displayDefinitions(risk.weaknesses) }}</td>
                <td>
                  <div v-if="policy.showRiskLinkPanel">
                    <i @click="unlinkRisk(risk, policy)" class="bx bx-trash-alt text-danger hand mr-4 float-left d-inline-block" v-b-tooltip.hover :title="$t('common.delete')"></i>
                    <i @click="redirectToRisk(risk._id)" class="bx bx-search text-primary hand" v-b-tooltip.hover :title="$t('risk.view')"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!------------>

    <!-- Begin: Pagination -->
    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import PolicyCategoryBadge from "./component/policy-category-badge";
import PolicyComplianceStatusDescription from "./component/policy-compliance-status-description";
import PolicyComplianceStatusSelect from "./component/policy-compliance-status-select";
import PolicyDeleteModal from "./component/policy-delete-modal";
import PolicyDetail from "./component/policy-detail";
import PolicyPeriodicalSelect from "./component/policy-periodical-select";
import PolicyStatusSelect from "./component/policy-status-select";
import RiskItem from "./component/risk-item";
import OrganizationPolicyForm from "./organization-policy-form.vue";

export default {
  props: ["product"],
  components: {
    PolicyStatusSelect,
    PolicyPeriodicalSelect,
    PolicyDeleteModal,
    PolicyComplianceStatusSelect,
    PolicyComplianceStatusDescription,
    RiskItem,
    PolicyCategoryBadge,
    PolicyDetail,
    OrganizationPolicyForm,
  },

  data() {
    return {
      selectedRisk: undefined,
      selectedTask: undefined,
      selectedComplianceStatus: undefined,
      selectedPolicy: undefined,
      workedFilter: undefined,
      complianceStatusesVisible: {},
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {
          status: { value: ["WAITING_FOR_ASSESSMENT"], isObject: true },
        },
      },

      nameFilter: undefined,
      categoryFilter: undefined,
      policyGroupFilter: undefined,
    };
  },
  computed: {
    selectedWorkedFilter() {
      return this.$store.getters["organizationPolicy/selectedWorkedFilter"];
    },
    selectedCategoryFilter: {
      get() {
        return this.$store.getters["organizationPolicy/selectedCategoryFilter"];
      },
      set(value) {
        this.$store.commit("organizationPolicy/selectedCategoryFilter", value);
      },
    },
    selectedPolicyGroupFilter() {
      return this.$store.getters["organizationPolicy/selectedPolicyGroupFilter"];
    },
    pagination() {
      return this.$store.getters["organizationPolicy/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationPolicy/isLoading"];
    },
    hasUnworkedPermission() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_DDO_PRODUCT_ADMIN",
          "ORGANIZATION_BGYS_PRODUCT_ADMIN",
          "ORGANIZATION_GDPR_ACCESS",
          "ORGANIZATION_KVKK_ACCESS",
          "ORGANIZATION_DDO_ACCESS",
          "ORGANIZATION_BGYS_ACCESS",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    selectedWorkedFilter: {
      immediate: true,
      handler(n, o) {
        this.workedFilter = n;
        this.$forceUpdate();
      },
    },
    selectedCategoryFilter: {
      immediate: true,
      handler(n, o) {
        if (n) {
          this.request.query = { ...this.request.query, category: { value: n, isObject: true } };
        } else {
          this.request.query["category"] = null;
          delete this.request.query["category"];
        }
        this.$forceUpdate();
      },
    },
    selectedPolicyGroupFilter: {
      immediate: true,
      handler(n, o) {
        this.policyGroupFilter = n;
        this.$forceUpdate();
      },
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },

    policyGroupFilter: {
      immediate: true,
      deep: true,
      handler(n, o) {
        if (n) {
          this.request.query = { ...this.request.query, "compliances.policyGroup": { value: n, isObject: true } };
        } else {
          this.request.query["compliances.policyGroup"] = null;
          delete this.request.query["compliances.policyGroup"];
        }
      },
    },

    workedFilter: {
      immediate: true,
      handler(n, o) {
        const q = { value: n, isObject: true };
        if (n == "COMPLETED") {
          q.value = ["COMPLETED"];
        }
        if (n == "NOT_APPLICABLE") {
          q.value = ["NOT_APPLICABLE"];
        }
        this.request.query["status"] = q;
      },
    },
  },
  mounted() {
    this.setInitialQuery();
  },
  methods: {
    displayDefinitions(array) {
      if (!array || !array.length) {
        return "";
      }
      return array.map((i) => i.name[this.currentLanguage]).join(", ");
    },
    setInitialQuery() {
      if (this.product) {
        this.request = { ...this.request, query: { ...this.request.query, products: { value: this.product, isObject: true } } };
      }
      if (this.$route?.query?.workedFilter) {
        this.workedFilter = this.$route.query?.workedFilter;
      }
    },
    onPolicyGroupSelect(value) {
      this.setPolicyGroupFilter(value);
    },
    async onPolicyGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`libraryPolicyGroup/paginate`, {
        options: { limit: 200, sort: { [`name.${this.currentLanguage || tr}`]: "asc" } },
        query: {
          name: { value },
          ...(this.currentProduct ? { products: { value: this.currentProduct, isObject: true } } : {}),
        },
      });

      callback(response.data?.docs ?? []);
    },
    toggleRightPanel() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-policy");
    },
    rightPanelClosed() {},
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { policy: item._id, policyName: item.name?.[this.currentLanguage] } });
    },
    setWorkedFilter(val) {
      if (val) {
        this.$store.commit("organizationPolicy/selectedWorkedFilter", val);
      }
    },

    setPolicyGroupFilter(val) {
      this.$store.commit("organizationPolicy/selectedPolicyGroupFilter", val);
    },
    icon(product) {
      if (product == "KVKK") {
        return "/icons/kvkk-active.svg";
      }
      if (product == "GDPR") {
        return "/icons/gdpr-active.svg";
      }
      if (product == "DDO") {
        return "/icons/ddo-active.svg";
      }
      if (product == "BGYS") {
        return "/icons/bgys-active.svg";
      }
    },
    periodEdited(event, policy) {
      this.fetchPolicyDetail(policy._id);
    },
    statusChanged(event, policy) {
      this.paginate();
    },
    createTask(compliance) {
      this.$store.commit("task/showTaskCreateModal", true);
    },
    async taskSaved() {
      this.$refs["taskFilter" + this.selectedComplianceStatus.definitionId]?.map((i) => i.reset());

      //burada tedbirin önceki statusu ile sonraki statusu değişti ise paginate çağırılsın şeklinde yapılabilir.
      this.fetchPolicyDetail(this.selectedPolicy._id);
    },
    showComplianceActions(compliance) {
      return compliance.acceptance != compliance.targetAcceptance;
    },
    async save(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      await this.$store.dispatch("organizationPolicy/changePolicyStatus", id);
      this.paginate();
    },
    redirectToRisk(id) {
      if (!id) {
        return;
      }
      this.$router.push(`/${this.currentProduct.toLowerCase()}/risk-detail/${id}?goBackPath=${this.currentProduct.toLowerCase()}/policy`);
    },
    async paginate() {
      await this.$store.dispatch("organizationPolicy/paginate", this.request);
    },
    selectElement(complianceStatus, policy, index) {
      const id = complianceStatus._id;
      policy.complianceStatuses.forEach((status) => {
        if (status._id !== id) {
          this.$set(this.complianceStatusesVisible, status._id, false);
        }
      });

      this.$set(this.complianceStatusesVisible, id, !this.complianceStatusesVisible[id]);

      this.selectedComplianceStatus = complianceStatus;
      this.selectedPolicy = policy;
    },
    openTaskDetailModal(task) {
      this.$store.commit("task/showTaskDetailModal", true);
      return this.$store.dispatch("task/fetchDetail", task._id);
    },
    edit(id) {
      this.$store.commit("organizationPolicy/isEditing", true);
      this.$store.commit("organizationPolicy/policyId", id);

      const path = `/${this.currentProduct && this.currentProduct != "PLATFORM" ? this.currentProduct.toLowerCase() : "organization"}/policy-detail/${id}`;

      this.$router.push(path);
    },
    create() {
      this.$store.commit("organizationPolicy/isCreating", true);
    },
    saveDescription() {
      try {
        this.$store.dispatch("organizationPolicy/updateComplianceStatusDescription", true);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async deleteModalHidden() {
      this.paginate();
    },
    async deletePolicy(policy) {
      try {
        policy.status = "NOT_APPLICABLE";
        this.$bvModal.show("policy-delete-modal" + policy._id);
      } catch (error) {}
    },
    async revertDeleted(policy) {
      try {
        policy.status = "WAITING_FOR_ASSESMENT";
        this.$bvModal.show("policy-delete-modal" + policy._id);
      } catch (error) {}
    },

    async unlinkRisk(risk, policy) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        // if (this.isEditing) {
        await this.$store.dispatch("organizationPolicy/removePolicyRiskRelation", {
          policyId: policy._id,
          riskId: risk._id,
        });
        // }

        policy.risks = policy.risks.filter((i) => i._id != risk._id);
        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithRisk(policy) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        //   if (this.isEditing) {
        const response = await this.$store.dispatch("organizationPolicy/addPolicyRiskRelation", {
          policyId: policy._id,
          riskId: this.selectedRisk._id,
        });

        policy.risks.push(response.data.risk);
        this.selectedRisk = undefined;
        policy.showRiskLinkPanel = false;

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));

        //this.$store.dispatch("organizationPolicy/fetchDetail", this.selectedPolicy._id);
        // } else {
        //   if (!this.form.risks.find((i) => i._id == this.selectedRisk._id)) {
        //     this.form.risks.push({ _id: this.selectedRisk._id, name: this.selectedRisk.name });
        //   }
        // }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onRiskSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationRisk/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onRiskSelect(risk) {
      this.selectedRisk = risk;
      this.$forceUpdate();
    },

    async unlinkTask(task, complianceStatus) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("task/removeTaskPolicyRelation", {
          policyId: this.selectedPolicy._id,
          taskId: task._id,
          complianceStatusDefinitionId: complianceStatus.definitionId,
        });

        complianceStatus.tasks = complianceStatus.tasks.filter((i) => i._id != task._id);

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithTask(complianceStatus) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const response = await this.$store.dispatch("task/addTaskPolicyRelation", {
          policyId: this.selectedPolicy._id,
          taskId: complianceStatus.selectedTask._id,
          complianceStatusDefinitionId: complianceStatus.definitionId,
        });
        //await this.$store.dispatch("organizationPolicy/fetchDetail", this.selectedPolicy._id);
        // this.paginate();
        complianceStatus.tasks.push(response.data.task);
        complianceStatus.selectedTask = undefined;
        complianceStatus.showTaskLinkPanel = false;

        this.$forceUpdate();

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onTaskSearch(value, callback) {
      const response = await this.$store.dispatch(`task/fetchOrganizationTasks`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onTaskSelect(task, complianceStatus) {
      complianceStatus.selectedTask = task;
      this.$forceUpdate();
    },

    async onComplienceTargetStatusUpdated(value, policy, complianceStatus) {
      complianceStatus.targetAcceptance = definition;
      this.fetchPolicyDetail(policy._id);
    },
    async onComplienceStatusUpdated(value, policy, complianceStatus) {
      complianceStatus.acceptance = value.definition;
      this.fetchPolicyDetail(policy._id);
      this.paginate();
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        if (this.workedFilter == "WAITING_FOR_ASSESSMENT") {
          payload.status = "WAITING_FOR_ASSESSMENT";
        } else if (this.workedFilter == "IN_PROGRESS") {
          payload.status = "IN_PROGRESS";
        } else if (this.workedFilter == "WAITING_FOR_PERIOD") {
          payload.status = "WAITING_FOR_PERIOD";
        } else if (this.workedFilter == "COMPLETED") {
          payload.status = "COMPLETED";
        } else if (this.workedFilter == "NOT_APPLICABLE") {
          payload.status = "NOT_APPLICABLE";
        }

        const { data: file } = await this.$store.dispatch(`organizationPolicy/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async fetchPolicyDetail(id) {
      try {
        await this.$store.dispatch("organizationPolicy/fetchDetailAndUpdateOnPaginate", id);
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-policy.scss";
</style>
